export const DatesFormatter = (date, options = { day: "numeric", month: "short", year: "numeric" }, localeLang) => {
    var _a;
    const language = (_a = localeLang !== null && localeLang !== void 0 ? localeLang : window.localStorage.getItem("i18nextLng")) !== null && _a !== void 0 ? _a : "it-IT";
    return new Intl.DateTimeFormat(language, options).format(date);
};
export const DatesFormatterRange = (startDate, endDate, options = { year: "2-digit", month: "numeric", day: "numeric" }, localeLang) => {
    var _a;
    const language = (_a = localeLang !== null && localeLang !== void 0 ? localeLang : window.localStorage.getItem("i18nextLng")) !== null && _a !== void 0 ? _a : "it-IT";
    return new Intl.DateTimeFormat(language, options).formatRange(startDate, endDate);
};
